import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import LocizeEditor from "locize-editor";

const packageJson = require("../../package.json");

const defaultNS = packageJson.config.locize_namespace;
const referenceLng = "ja-JP";
const projectId = packageJson.config.locize_project_id;

const promise = i18next
  .use(LanguageDetector)
  .init({
    ns: [defaultNS],
    defaultNS: defaultNS,
    fallbackLng: referenceLng,
    saveMissing: true,
    resources: {
      [referenceLng]: {
        [defaultNS]: require(
          `@/resources/languages/${referenceLng}/${defaultNS}.json`,
        ),
      },
    },
  })
  .then((t) => {
    if (
      process.env.NEXT_PUBLIC_ENVIRONMENT !== "production" &&
      typeof document !== "undefined"
    ) {
      LocizeEditor.init({
        lng: referenceLng,
        referenceLng: referenceLng,
        defaultNS: defaultNS,
        projectId: projectId,
      });
    }
    return t;
  });

if (process.env.NEXT_PUBLIC_ENVIRONMENT !== "production") {
  i18next.on("missingKey", (lngs, namespace, key, res) => {
    console.error(`i18next missingKey`, lngs, namespace, key, res);
  });
}

export const i18n = {
  promise,
  i18next,
};
